import type { ApiRequestFn, QueryParams } from "../../types/api";
import type { Invoice, PaginatedResponse, Status } from "../../types/models";
import type { InvoiceDetail } from "../../types/payment";
import { buildQueryString } from "../../utils/query";

const createInvoicesApi = (request: ApiRequestFn) => ({
  list: (params?: QueryParams) => {
    const qs = buildQueryString(params);
    return request<PaginatedResponse<Invoice>>(`/me/invoices${qs ? `?${qs}` : ""}`);
  },

  pending: () => request<Invoice[]>(`/me/invoices/pending`),

  get: (id: number) => request<InvoiceDetail>(`/me/invoices/${id}`),

  updateStatus: (id: number, status: Status) =>
    request<InvoiceDetail>(`/me/invoices/${id}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
    }),

  remove: (id: number) => request<void>(`/me/invoices/${id}`, { method: "DELETE" }),

  download: (id: number) => request<Blob>(`/me/invoices/${id}/download`, {}, (res) => res.blob()),
});

export { createInvoicesApi };
